<div class="discount-container px-medium radius-medium c-2">
  <div class="py-medium mw-50 text-align-center d-flex justify-content-center align-items-center">
    <span class="text-align-right">{{ title() }}</span>
  </div>
  <div class="d-flex flex-column justify-content-space-between">
    <div class="circle"></div>
    <div class="divider"></div>
    <div class="circle"></div>
  </div>
  <div
    class="d-flex justify-content-center align-items-center px-medium flex-grow"
    (click)="copyToClipboard()"
  >
    <div class="radius-giant gap-micro d-flex align-items-center surface-glass-invert p-low cursor-pointer">
      <common-icon-dp-icon
        [icon]="'document-copy'"
        [iconSize]="'16'"
      ></common-icon-dp-icon>
      <span class="c-2">{{ code() }}</span>
    </div>
  </div>
</div>
